import axios from 'services/axios-interceptors';
import { API_PATH } from 'store/service';

export const appConfigurationServices = {
  getAppConfiguration() {
    return axios.get(API_PATH + '/get/appConfig');
  }
};
